import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import store from './store';
import './resources/style/main.scss';
import FullscreenIndicator from './components/common/loading-indicator/FullscreenIndicator';
import { userActionTypes } from './actions/ActionTypes';

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <FullscreenIndicator actions={[userActionTypes.fetchUser]} />
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root'),
);
